import React, { useState } from 'react';
import { WorkersList } from '../../components/WorkersList/WorkersList';
import { mockWorkersList, mockKpiItems } from '../../../_shared/mocks';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Button } from '../../../_shared/components/Button/Button';
import { ReactComponent as InfoIcon } from '../../../_shared/assets/icons/info-icon.svg';
import { ReactComponent as PlusIcon } from '../../../_shared/assets/icons/plus.svg';
import { ReactComponent as PdfIcon } from '../../../_shared/assets/icons/pdf-icon.svg';
import { KpiTable } from '../../../_shared/components/KpiTable/KpiTable';
import { Card } from '../../../_shared/components/Card/Card';
import { KpiFormModal } from '../../../_shared/components/KpiFormModal/KpiFormModal';
import { Select } from '../../../_shared/components/Select/Select';
import { Input } from '../../../_shared/components/Input/Input';
import { ReactComponent as SearchIcon } from '../../../_shared/assets/icons/searchIcon.svg';
import { useKpeSelector } from '../../../_shared/store/store';
import styles from './ManagerView.module.scss';

const DEPARTMENTS = [
  'Департамент A',
  'Департамент B',
  'Департамент C',
  'Все подразделения'
];
const CATEGORIES = ['Категория1', 'Категория2', 'Категория3', 'Категория4'];
const SORT_OPTIONS = ['Сначала новые', 'Сначала старые'];

export function ManagerView() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState<string>('');
  const [selectedCategories, setSelectedCategories] = useState<string>('');
  const [selectedSort, setSelectedSort] = useState<string>('');
  const hasKpi = useKpeSelector((s) => s.kpe.hasKpi);

  return (
    <div className={styles.view}>
      <div className={styles.section}>
        <div className={styles.head}>
          <div className={styles.headInfo}>
            <Typography variant="h2">Мои КПЭ</Typography>
            <Typography variant="text">
              КПЭ помогают зафиксировать приоритеты на год и сделать результат
              измеримым. Рекомендуется задать от 3 до 7 показателей.
              <br />
              По итогам выполнения показателей рассчитывается уровень
              эффективности и размер премии.
            </Typography>
          </div>
          <Button
            className={styles.pdfBtn}
            variant={'secondary'}
            onClick={() => alert('Скачать PDF')}
          >
            Скачать <PdfIcon />
          </Button>
        </div>
        {!hasKpi && (
          <Card>
            <div className={styles.emptyBlock}>
              <InfoIcon className={styles.infoIcon} />
              <div className={styles.emptyContent}>
                <Typography variant="h5">
                  Сформируйте план КПЭ на год
                </Typography>
                <Typography className={styles.emptyText} variant="text">
                  Укажите плановые значения, методику расчёта и ответственные
                  подразделения.
                  <br />
                  Вы можете изменить показатели и согласовать их с
                  руководителем.
                </Typography>
                <Button
                  className={styles.emptyExampleBtn}
                  variant="disabled"
                  onClick={() => alert('Пример таблицы')}
                >
                  Пример таблицы
                </Button>
              </div>
            </div>
            <Button
              className={styles.emptyAddBtn}
              variant="secondary"
              onClick={() => setIsModalOpen(true)}
            >
              Добавить KPI&nbsp;{' '}
              <span>
                <PlusIcon />
              </span>
            </Button>
          </Card>
        )}

        {hasKpi && (
          <Card>
            <KpiTable
              rows={mockKpiItems}
              editable
              onKpiClick={(row) => console.log('kpi click', row)}
              onEdit={(row) => console.log('edit', row)}
              onDelete={(row) => console.log('delete', row)}
            />
            <div className={styles.actions}>
              <Button
                className={styles.actionAdd}
                variant="secondary"
                onClick={() => setIsModalOpen(true)}
              >
                Добавить KPI&nbsp;{' '}
                <span>
                  <PlusIcon />
                </span>
              </Button>
              <Button
                className={styles.actionSend}
                variant="primary"
                onClick={() => alert('Отправить на согласование')}
              >
                Отправить на согласование
              </Button>
            </div>
          </Card>
        )}
      </div>

      <div className={styles.myWorkers}>
        <div className={styles.head}>
          <div className={styles.headInfo}>
            <Typography variant="h2">Мои работники</Typography>
            <Typography variant="text">
              КПЭ работников, используется для оценки выполнения задач
              подразделения и принятия управленческих решений.
              <br />
              Результаты учитываются при расчёте уровня эффектинвости и премии.
            </Typography>
          </div>
          <Button
            className={styles.pdfBtn}
            variant={'secondary'}
            onClick={() => alert('Скачать PDF')}
          >
            Скачать <PdfIcon />
          </Button>
        </div>
        <form className={styles.form}>
          <div className={styles.searchWrapper}>
            <Input
              label="Поиск по ФИО и должности"
              name="search"
              type="text"
              value={searchQuery}
              variant={'grey'}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
            />
            <SearchIcon className={styles.searchIcon} />
          </div>
          <div className={styles.selectors}>
            <div className={styles.filters}>
              <Select
                label="Подразделения"
                options={DEPARTMENTS}
                value={selectedDepartment}
                onChange={(value) => setSelectedDepartment(value ?? '')}
              />
            </div>
            <div className={styles.filters}>
              <Select
                label="Категория"
                options={CATEGORIES}
                value={selectedCategories}
                onChange={(value) => setSelectedCategories(value ?? '')}
              />
            </div>
            <div className={styles.filters}>
              <Select
                label="Сначала новые"
                options={SORT_OPTIONS}
                value={selectedSort}
                onChange={(value) => setSelectedSort(value ?? '')}
              />
            </div>
          </div>
        </form>
      </div>

      <WorkersList workers={mockWorkersList} />

      <KpiFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(values) => console.log('submit', values)}
        notification={'Текст возможного уведомления'}
      />
    </div>
  );
}
